import React from 'react'
import { useHistory } from "react-router-dom";

function PageBtn(props){
    const {pageDelegate, pathUserid, handleShowPage, currentPathTitle, setPathUserid, setPathTitle} = props
    const history = useHistory();
    
    const getClassName = (pageDelegate)=>{
        let baseClass = '';
        if(pageDelegate.public){
            baseClass = (pageDelegate.title===currentPathTitle.current?"btn btn-primary public": "btn btn-secondary public")
        }else{
            baseClass = (pageDelegate.title===currentPathTitle.current?"btn btn-primary private": "btn btn-secondary private")
        }
        
        // Add default-page class if this page is the default page
        if(pageDelegate.default) {
            baseClass += " default-page"
        }
        
        return baseClass
    }
    
    const handleNewPath = (e) => {
        e.preventDefault();
        
        // Update state first
        setPathUserid(pathUserid);
        setPathTitle(pageDelegate.title);
        
        // Then navigate
        history.push(`/${pathUserid}/${pageDelegate.title}`);
    }
    
    const isPublic = pageDelegate.public === true
    
    return(
        <button className={getClassName(pageDelegate)} onClick={handleNewPath}>
            {pageDelegate.title}
            <i className={`privacy-icon ${isPublic ? 'public-icon' : 'private-icon'}`}></i>
            <i className="settings" onClick={(e) => {
                e.stopPropagation();
                handleShowPage(pageDelegate)(e);
            }}></i>
        </button>
    )
}

export default PageBtn